<template>
  <v-container>
    <div>
      <span v-html="title"></span>
    </div>
    <div>
      <div class="flex-container">
        <!-- Table 1 -->
        <div>
          <table
            style="height: 43px"
            width="400px;"
            border="1px;"
            cellspacing="0px;"
          >
            <tbody>
              <tr>
                <td class="row-data">ប្រភេទ</td>
                <td class="row-data">ទីធ្លា</td>
                <td class="row-data">សម្ភារ</td>
                <td class="row-data">ក្រុមកីឡា</td>
              </tr>
              <tr v-for="(value, row) in sportUtil.length" :key="row">
                <td class="row-data-left">{{ sportUtil[row] }}</td>
                <td
                  v-for="(value, col) in fdata[row].dt.length"
                  :key="col"
                  class="row-data"
                >
                  <v-select
                    class="py-0 px-1"
                    v-model="fdata[row].dt[col]"
                    :items="yesNo6"
                    item-text="text"
                    item-value="value"
                    outline
                    hide-details
                    @keypress.native="onSelect($event, row, col)"
                  >
                  </v-select>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- Table 2 -->
        <div>
          <table
            style="height: 43px"
            width="400px;"
            border="1px;"
            cellspacing="0px;"
          >
            <tbody>
              <tr>
                <td class="row-data">ប្រភេទ</td>
                <td class="row-data">ទីធ្លា</td>
                <td class="row-data">សម្ភារ</td>
                <td class="row-data">ក្រុមកីឡា</td>
              </tr>
              <tr v-for="(value, row2) in sportUtil2.length" :key="row2">
                <td class="row-data-left">{{ sportUtil2[row2] }}</td>
                <td
                  v-for="(value, col2) in sdata[row2].dt.length"
                  :key="col2"
                  class="row-data"
                >
                  <v-select
                    class="py-0 px-1"
                    v-model="sdata[row2].dt[col2]"
                    :items="yesNo6"
                    item-text="text"
                    item-value="value"
                    outline
                    hide-details
                    @keypress.native="onSelect2($event, row2, col2)"
                  >
                  </v-select>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import { sportUtil, sportUtil2, yesNo6 } from "@/utils/ascf/commonConfig.js";
export default {
  props: ["fdata", "sdata", "title"],
  data() {
    return {
      yesNo6: yesNo6,
      sportUtil: sportUtil,
      sportUtil2: sportUtil2,
    };
  },
  methods: {
    onSelect: function (event, row, col) {
      var charCode = event.keyCode;
      if (charCode >= 49 && charCode <= 50) {
        this.fdata[row].dt[col] = charCode - 48;
        this.$forceUpdate();
      }
    },
    onSelect2: function (event, row, col) {
      var charCode = event.keyCode;
      if (charCode >= 49 && charCode <= 50) {
        this.sdata[row].dt[col] = charCode - 48;
        this.$forceUpdate();
      }
    },
  },
};
</script>
<style scoped>
.flex-container {
  display: flex;
}
.flex-container-group {
  display: flex;
  flex-wrap: stretch;
  flex-direction: column;
}
.row-data {
  width: 100px;
  height: 32px;
  text-align: center;
  vertical-align: middle;
}
.row-data-left {
  width: 100px;
  height: 32px;
  text-align: left;
  vertical-align: middle;
}
.input-group--select >>> .input-group__selections__comma {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  font-size: 12px;
  padding: 1px 1px 1px 0;
}
.v-input {
  font-size: 12px;
}
</style>